<template>
  <PVToggleSwitch
    v-bind="{ ...$props, ...$attrs }"
    v-model="model"
    :class="{
      'standard-switch': true,
      'standard-switch--sm': size === 'sm',
    }"
  />
</template>
<script lang="ts">
/**
 * Until Product has updated the design tokens to expose the control sizes (which PrimeVue does not support natively),
 * this component uses some hardcoded CSS variable values (provided by John) to set the size of the switch.
 */
export default {
  name: 'StandardSwitch',
  compatConfig: { MODE: 3 },
};
</script>
<script setup lang="ts">
const model = defineModel<boolean>({ required: true });

withDefaults(
  defineProps<{
    size?: 'sm' | 'md' | 'lg';
  }>(),
  {
    size: 'md',
  },
);
</script>
<style scoped>
.standard-switch {
  --p-toggleswitch-checked-background: var(--p-primary-color);
  --p-toggleswitch-checked-hover-background: var(--p-primary-color);

  display: inline-flex;
  flex-shrink: 0;
  line-height: 1;
  vertical-align: middle;
}

.standard-switch--sm.p-toggleswitch {
  --p-toggleswitch-width: 1.75rem;
  --p-toggleswitch-height: 1rem;
  --p-toggleswitch-gap: 0.125rem;
  --p-toggleswitch-border-radius: 1.25rem;

  --p-toggleswitch-handle-size: 0.75rem;
  --p-toggleswitch-handle-border-radius: 0.375rem;
}
</style>
